export default "__VITE_ASSET__CfmsT8Rq__"